import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/bonos';
export function BonosSection() {
  return <section className="w-full bg-[#0f172a] py-20 sm:py-28" aria-labelledby="bonos-title" data-id="element-14" data-mp="186qreajnbxkl">
      <div className="mx-auto w-full max-w-6xl px-6" data-id="element-15" data-mp="13btc4lvrwrz9">
        <div className="mx-auto max-w-2xl text-center" data-id="element-16" data-mp="yfmcfatz0cpr">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400" data-id="element-17" data-mp="yd06ffmqa59n">
            6 Bonos Exclusivos Incluidos
          </p>
          <h2 id="bonos-title" className="mt-6 font-serif text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl" data-id="element-18" data-mp="oflpzg0t1ghc">
            Más de <span className="text-[#fbbf24]" data-id="element-19" data-mp="kh5xwxpv9hx2">$174.000 ARS</span> en Bonos. Sin
            Costo Extra.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-400" data-id="element-20" data-mp="2et2t91rfj7xe">
            Cada bono resuelve un problema específico que los Tomos no cubren solos.
          </p>
        </div>

        <ul className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="29rwxev2h34jn">
          {bonos.map((bono, index) => <motion.li key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.45,
          delay: index % 3 * 0.08
        }} className="relative flex flex-col rounded border border-white/10 bg-white/[0.03] p-7 pt-9 transition-colors duration-200 hover:border-[#d97706]/50" data-id="element-22" data-mp="qxineivqlfc9" data-mpi={index}>
              <span className="absolute -top-3 left-6 inline-flex items-center gap-1.5 rounded bg-[#d97706] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-23" data-mp="1ejp7w4mcknjd">
                <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-24" data-mp="15rvlw2o1ukme" />
                {bono.id}
              </span>
              <h3 className="font-serif text-lg font-bold leading-snug text-white" data-id="element-25" data-mp="1thhkop0iextv">
                {bono.title}
              </h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#fbbf24]" data-id="element-26" data-mp="1yb2l0npks3w8">
                {bono.category}
              </p>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-400" data-id="element-27" data-mp="235lq7963rnk9">
                {bono.description}
              </p>
              <p className="mt-6 border-t border-white/10 pt-4 text-sm font-bold text-[#fbbf24]" data-id="element-28" data-mp="1y4xsy5ra6ahl">
                {bono.value}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}